import { Button, UIText2 } from '@cian/ui-kit';
import * as styles from './styles.css';
import { ETestIds } from '../../constants';

interface IFillApplicationStickyButtonProps {
  onClick: () => void;
}

export const FillApplicationStickyButton = ({ onClick }: IFillApplicationStickyButtonProps) => {
  return (
    <div className={styles['mobile-btn']} data-testid={ETestIds.MobileCtaButton}>
      <div className={styles['mobile-wrapper']}>
        <Button fullWidth size="M" onClick={onClick} data-testid={ETestIds.MainButton}>
          Заполнить заявку на Циане
        </Button>
        <UIText2 textAlign={'center'} color={'text-secondary-default'}>
          Заявка единая для всех банков
        </UIText2>
      </div>
    </div>
  );
};
